export enum Language {
    En = 0,
    Ar = 1,
}
